import { GlobalAxios } from "../axios/axios-config";
import { ICancelationReason } from "../models/cancelation-reason";
import { ITicketAutomationReceivedRuleCancelationReason } from "../models/ticket-automation-received-rule-cancelation-reason";

const TICKET_AUTOMATION_RECEIVED_RULE_CANCELATION_REASON_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRuleCancelationReason/";

const CALENDAR_EXAM_CANCELATION_REASON_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/CalendarExamCancellationReason";

const CALENDAR_CONSULTATION_CANCELATION_REASON_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/CalendarConsultationCancellationReason";

export const createTicketAutomationReceivedRuleCancelationReason = (
  item: ITicketAutomationReceivedRuleCancelationReason,
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULE_CANCELATION_REASON_ROUTE,
    item,
  );
};

export const getTicketAutomationReceivedRuleCancelationReasonById = (
  id: string,
) => {
  return GlobalAxios.get<ITicketAutomationReceivedRuleCancelationReason>(
    TICKET_AUTOMATION_RECEIVED_RULE_CANCELATION_REASON_ROUTE + id,
  );
};

export const updateTicketAutomationReceivedRuleCancelationReasonById = ({
  item,
  id,
}: {
  item: ITicketAutomationReceivedRuleCancelationReason;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULE_CANCELATION_REASON_ROUTE + id,
    item,
  );
};

export const calendarExamCancelationReasonList = () => {
  return GlobalAxios.get<ICancelationReason[]>(
    CALENDAR_EXAM_CANCELATION_REASON_ROUTE + "/CalendarExamCancellationReasons",
  );
};

export const calendarConsultationCancelationReasonList = () => {
  return GlobalAxios.get<ICancelationReason[]>(
    CALENDAR_CONSULTATION_CANCELATION_REASON_ROUTE +
      "/CalendarConsultationCancellationReasons",
  );
};
